export default __webpack_public_path__ + "6814ec03f9e0da72f534d44bf89a7ed7.png";